import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { toast } from "react-hot-toast";
import { LOG_ACTIONS } from "./log-action-constants";

const API_HOST_CRM = CONFIG.modules["crm"].host;

export const ExportLogsModal = ({ open, onClose }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");
  const [exportLoading, setExportLoading] = useState(false);

  const handleExport = async () => {
    setExportLoading(true);
    const queryParams = new URLSearchParams();

    if (fromDate)
      queryParams.append("from", dayjs(fromDate).format("YYYY-MM-DD"));
    if (toDate) queryParams.append("to", dayjs(toDate).format("YYYY-MM-DD"));
    if (selectedAction) queryParams.append("action", selectedAction);

    axios
      .get(`${API_HOST_CRM}/export-case-logs?${queryParams.toString()}`, {
        responseType: "blob",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `logs_${dayjs(fromDate).format("YYYY-MM-DD")}_to_${dayjs(
            toDate
          ).format("YYYY-MM-DD")}${
            selectedAction ? `_${selectedAction}` : ""
          }.xlsx`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        toast.success("Logs exported successfully");
        onClose();
      })
      .catch((e) => {
        console.error("Error exporting logs:", e);
        toast.error("Error exporting logs");
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  const setQuickDate = (type) => {
    const today = dayjs();

    switch (type) {
      case "today":
        setFromDate(today.startOf("day"));
        setToDate(today.endOf("day"));
        break;
      case "thisWeek":
        setFromDate(today.startOf("week"));
        setToDate(today.endOf("week"));
        break;
      case "thisMonth":
        setFromDate(today.startOf("month"));
        setToDate(today.endOf("month"));
        break;
      default:
        break;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Export Logs
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Stack spacing={3}>
            <Stack direction="row" spacing={2}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={setFromDate}
                slotProps={{
                  textField: { fullWidth: true },
                }}
              />
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={setToDate}
                slotProps={{
                  textField: { fullWidth: true },
                }}
              />
            </Stack>

            <FormControl fullWidth>
              <InputLabel>Action Type</InputLabel>
              <Select
                value={selectedAction}
                onChange={(e) => setSelectedAction(e.target.value)}
                label="Action Type"
              >
                <MenuItem value="">
                  <em>All Actions</em>
                </MenuItem>
                {Object.values(LOG_ACTIONS).map((action) => (
                  <MenuItem key={action} value={action}>
                    {action}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={() => setQuickDate("today")}>
                Today
              </Button>
              <Button
                variant="outlined"
                onClick={() => setQuickDate("thisWeek")}
              >
                This Week
              </Button>
              <Button
                variant="outlined"
                onClick={() => setQuickDate("thisMonth")}
              >
                This Month
              </Button>
            </Stack>

            <Button
              variant="contained"
              disabled={!fromDate || !toDate || exportLoading}
              onClick={handleExport}
              fullWidth
            >
              {exportLoading ? "Exporting..." : "Export"}
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
